export default __webpack_public_path__ + "static/media/miguel-lopes-27.3b1a21d8.jpg";